import { render } from "./VotingClosed.vue?vue&type=template&id=6fac8861&ts=true"
import script from "./VotingClosed.vue?vue&type=script&lang=ts"
export * from "./VotingClosed.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Dunder\\Documents\\Projects\\Heyou\\Awards\\live-voting-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__